// IMPORT PACKAGE REFERENCES

import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, Switch, Route} from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DSRouter } from './DSRouter';
import { PrivateRoute } from './PrivateRoute';
import { HomePage } from '../pages/HomePage';

import { FormLoader } from'../../forms/FormLoader';
import { PathwayReferenceHelper } from '../../forms/PathwayReferenceHelper';
import { ReferenceDataLoader } from '../../forms/ReferenceDataLoader';
import { getPathwayIdFromURL, QuidelOrthoPathWay } from '../../helpers/URLHelper';
import { ENVIRONMENT } from '../../config/config';
import { FormsStyles } from '../../../src/waferJS/FormsUI/FormsUI';

/* 
    Manage the authorisation and routing of the user based on the provided URL parameters. 
*/
class AppRouter extends React.Component {
    constructor(props) {
        super(props);
    }

    pathwayValid() {
        let pathwayId = getPathwayIdFromURL();
        if(FormLoader.validPathways.includes(pathwayId)){
            document.title = 'Wayfind | ' + PathwayReferenceHelper.reference('title', ReferenceDataLoader.referenceData(pathwayId));
            
            // Change primary color for QuidelOrtho
            const quidelPathway = (pathwayId === QuidelOrthoPathWay);
            if (quidelPathway) {
                FormsStyles.quidelStyle = true;
            }
            const root = document.documentElement;
            if (root) {
                root.style.setProperty('--accent-color', quidelPathway ? '#774EEF' : '#00A1F1');
                root.style.setProperty('--primary-tint', quidelPathway ? '#774EEF' : '#00A1F1');
            }
            
            return true;
        }

        return false;
    }

    constructURLForRedirect() {
        let url = 'https://access.wayfind.health/';
        var parameters = [];

        if (['dev', 'test', 'staging', 'demo'].includes(ENVIRONMENT.toLowerCase())) {
            parameters.push('env=' + ENVIRONMENT.toLowerCase());
        }
        
        let pathwayId = getPathwayIdFromURL();
        if (pathwayId.length > 0) {
            parameters.push('code=' + pathwayId);
        } else {
            return 'https://wayfind.health';
        }
        
        if (parameters.length > 0) {
            var urlWithParameters = url + '?' + parameters.join('&');

            return urlWithParameters;
        } else {
            return url;
        }
    }

    shouldRedirect() {
        if (this.pathwayValid()) {
            return {shouldRedirect: false, path: ''};
        }
         
        return {shouldRedirect: true, path: this.constructURLForRedirect()};
    }

    render() {
        let redirect = this.shouldRedirect();
        return (
            <BrowserRouter>
                <Switch>
                    {redirect.shouldRedirect && <Route path='/' component={() => { 
                        window.location = redirect.path; 
                        return null;
                    }}/>}
                    <PrivateRoute path='/' exact component={HomePage}/>
                    <DSRouter />
                </Switch>
            </BrowserRouter>
        );
    }
}

AppRouter.propTypes = {
    loggingIn: PropTypes.bool.isRequired,
    redirectPathway: PropTypes.string,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggingIn, redirectPathway } = state.userReducer;
    return { loggingIn, redirectPathway };
};

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AppRouter);

// EXPORT COMPONENT
export { hoc as AppRouter };


// WEBPACK FOOTER //
// ./src/components/routers/AppRouter.js